import { Filter, ItemList } from '../../types/main';
import { getQueryData } from '../../utility/helpers';

export const getActualFilters = (requiredFilters: Filter[] | undefined, data: ItemList<any> | null) => {
  const queryData = getQueryData();
  const actualFilters = data ? data.filters : queryData!.filters;

  if (requiredFilters) {
    requiredFilters.forEach((filter) => {
      const activeFilter = actualFilters.active.findIndex((actFilter: Filter) => actFilter.key === filter.key);

      if (activeFilter !== -1) {
        // eslint-disable-next-line no-param-reassign
        actualFilters.active[activeFilter] = filter;
      } else {
        actualFilters.active.push(filter);
      }
    });
  }

  return actualFilters;
};
